/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import TDate from './boot-vue-functions'

window.Vue = require('vue');

import VueLoading from 'vuejs-loading-plugin'
Vue.use(VueLoading, {
    dark: true, // default false
    text: 'Carregando..', // default 'Loading'
    loading: false, // default false
    classes: ['loading-screen-inspinia', 'animated', 'fadeIn'] // array, object or string
});

const app = new Vue({
    el: '#app',
    methods: {
        dateFormatBR: TDate.dateBR,
        dateFormatUS: TDate.dateUS,
    },
    components: {

        LinkDestroyComponent: () => import('./components/LinkDestroyComponent' /* webpackChunkName: "js/async-link-destroy-component" */),
        OrderSummaryComponent: () => import('./components/OrderSummaryComponent' /* webpackChunkName: "js/async-order-summary-component" */),
        CheckoutComponent: () => import('./components/CheckoutComponent' /* webpackChunkName: "js/async-checkout-component" */),
        UserAddressComponent: () => import('./components/UserAddressComponent' /* webpackChunkName: "js/async-user-address-component" */),
        ViewCounterProduct: () => import('./components/ViewCounterProduct' /* webpackChunkName: "js/async-view_counter-product" */),
        RibbonProduct: () => import('./components/RibbonProduct' /* webpackChunkName: "js/async-ribbon-product" */),
        PaymentComponent: () => {
            return new Promise((resolve, reject) => {
                let script = document.createElement('script');
                script.onload = () => {
                    resolve(import('./components/PaymentComponent'))
                };
                script.async = true;
                script.src = 'https://assets.pagar.me/checkout/1.1.0/checkout.js';
                document.head.appendChild(script);
            })
        }
    },
});

$('#app').tooltip({
    //selector: '[data-toggle="tooltip"]'
    selector: "[data-tooltip=tooltip]",
});
